import { createStore } from 'vuex'
import AV from 'leancloud-storage'

export default createStore({
  state: {
    checklistItems: [],
    categories: [],
    currentUser: null
  },
  mutations: {
    setChecklistItems(state, items) {
      state.checklistItems = items
    },
    setCategories(state, categories) {
      state.categories = categories
    },
    setCurrentUser(state, user) {
      state.currentUser = user
    }
  },
  actions: {
    async fetchChecklistItems({ commit }) {
      const query = new AV.Query('ChecklistItem')
      query.equalTo('user', AV.User.current())
      query.include('category')
      const items = await query.find()
      commit('setChecklistItems', items)
    },
    async fetchCategories({ commit }) {
      const query = new AV.Query('Category')
      query.equalTo('user', AV.User.current())
      const categories = await query.find()
      commit('setCategories', categories)
    }
  }
}) 